import { AText, Box, Button } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { Icon } from '@namespace/icons2';

import styles from './index.module.css';

export const WithdrawalLimitToastMessage = ({
  isPassportInVerification,
  onClick
}) => {
  const { t } = useI18n();

  return (
    <Box className={styles.wrapper} gap="m" direction="column">
      <Box gap="s">
        <Icon
          className={styles.icon}
          name="icons/general/item/shield"
          size="ms"
        />
        <Box direction="column" className={styles.content}>
          <AText size="m" color="po_txt_color_1">
            {t(
              isPassportInVerification
                ? 'web.balance.withdrawal.notification.inverification'
                : 'web.balance.withdrawal.notification.notverified'
            )}
          </AText>
          {!isPassportInVerification && (
            <Button
              className={styles.button}
              actionType="color5"
              intent="secondary"
              onClick={onClick}
            >
              {t('web.balance.withdrawal.notification.notverified.button')}
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};
